import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ClientKPIRow from './components/ClientKPIRow';
import ClientAgentList from './components/ClientAgentList';
import ClientActivityFeed from './components/ClientActivityFeed';
import ClientUpgradeCTA from './components/ClientUpgradeCTA';
import UsageMeter from './components/UsageMeter';
import { clientChangeRequests, clientProfile } from '../../mocks/client';
import DataModeBadge from '../../components/feedback/DataModeBadge';

function ClientHomePage() {
  const navigate = useNavigate();

  return (
    <main className="portal-page">
      <header className="portal-page-head">
        <div>
          <p className="eyebrow">YOUR PORTAL</p>
          <h1>
            Welcome back{' '}
            <DataModeBadge mode="sample" label="Sample data — backend pending" />
          </h1>
          <span>
            {clientProfile.name} · your agents are working. Everything here is
            read-only — ask us for changes and we make them.
          </span>
        </div>
      </header>

      <ClientKPIRow />

      <div className="portal-columns">
        <div className="portal-col-main">
          <ClientAgentList onRequestChange={() => navigate('/client/support')} />
          <ClientActivityFeed limit={3} />
        </div>
        <aside className="portal-col-side">
          <UsageMeter />
          <section className="portal-card">
            <div className="portal-card-head">
              <div>
                <h2>Change requests</h2>
                <span>You request, the agency delivers</span>
              </div>
              <Link className="portal-link-button" to="/client/support">New request</Link>
            </div>
            <ul className="portal-request-list">
              {clientChangeRequests.map((request) => (
                <li key={request.id}>
                  <p>{request.title}</p>
                  <span>Filed {request.filedOn} · {request.status.replace('-', ' ')}</span>
                </li>
              ))}
              {!clientChangeRequests.length && (
                <li className="portal-empty">No open requests.</li>
              )}
            </ul>
          </section>
          <ClientUpgradeCTA onOpenBillingPortal={() => navigate('/client/billing')} />
        </aside>
      </div>
    </main>
  );
}

export default ClientHomePage;
